import React from "react";
export const LightningOffIcon = () => (
  <svg
    width="30"
    height="32"
    viewBox="0 0 30 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7503 8.5L8.25031 17.5H15.0003L14.2503 23.5L21.7503 14.5H15.0003L15.7503 8.5Z"
      stroke="#808192"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
